import React from 'react'
import {Modal} from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TradeMBD = ({show,close}) => {
    return (
        <Modal show={show} onHide={close} centered className='trade-custom-modal'>
            <Modal.Body className=''>
                <div className='d-grid gap-4 text-center'>
                    <Link className='tradeLink' to="https://app.uniswap.org/explore/tokens/ethereum/0xa08898cabe14680cdfea55398143bc120889182e" target='_blank'>MEXC</Link>
                    <Link className='tradeLink' to="https://www.mexc.com/login?inviteCode=1caSw" target='_blank'>Uniswap</Link>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default TradeMBD;